export const UPDATE_EVENT_STATE = "UPDATE_EVENT_STATE"
export const EVENT_UPDATED = 'EVENT_UPDATED'
export const EVENT_CREATED = 'EVENT_CREATED'
export const EVENT_DELETED = 'EVENT_DELETED'
